import React from "react";
import { Box, Paper } from "@mui/material";
import FolderList from "./FolderList";
import SharePointFolderList from "./SharePointFolderList";
import FileExtensionPickerHome from "./FileExtensionPickerHome";
import DownloadRulePicker from "./DownloadRulePicker";
import PredefinedRulesManager from "./PreDefinedRulesManager";
import MailboxRuleManager from "./MailboxRuleManager";
import ServerControl from "./ServerControl";
import DownloadLogs from "./DownloadLogs";
import LogsDialog from "./LogsDialog";

const HomeContent = ({
  selectedComponent,
  accessToken,
  officeUser,
  selectedFolders,
  baseUrl,
  username,
  allowed,
  handleLogsVisibilityChange,
  logsDialogOpen,
  handleCloseLogsDialog,
  selectedFolderId,
  destinationFolderId,
}) => (
  <>
    <Box sx={{ mt: 4 }}>
      <Paper elevation={3} className="card">
        {selectedComponent === "FolderList" && (
          <FolderList accessToken={accessToken} userId={officeUser?.username} />
        )}
        {selectedComponent === "SharePointFolderList" && (
          <SharePointFolderList accessToken={accessToken} userId={officeUser?.username} />
        )}
        {selectedComponent === "FileExtensionPickerHome" && (
          <FileExtensionPickerHome folders={selectedFolders} userId={officeUser?.username} />
        )}
        {selectedComponent === "DownloadRulePicker" && (
          <DownloadRulePicker folders={selectedFolders} userId={officeUser?.username} />
        )}
        {selectedComponent === "PreDefinedRulesManager" && <PredefinedRulesManager />}
        {selectedComponent === "MailboxRuleManager" && (
          <MailboxRuleManager accessToken={accessToken} userId={officeUser?.username} />
        )}
        {selectedComponent === "ServerControl" && (
          <ServerControl
            baseUrl={baseUrl}
            username={username}
            allowed={allowed}
            onLogsVisibilityChange={handleLogsVisibilityChange}
          />
        )}
        {selectedComponent === "DownloadLogs" && <DownloadLogs />}
      </Paper>
    </Box>
    {logsDialogOpen && (
      <LogsDialog
        open={logsDialogOpen}
        onClose={handleCloseLogsDialog}
        selectedFolderId={selectedFolderId}
        destinationFolderId={destinationFolderId}
      />
    )}
  </>
);

export default HomeContent;
